import { api } from '@/api/core';
import { CHAT_SHARING_TAG } from '@/api/constants';
import { ChatAccessType, GetChatInvitedUsersRequest, GetChatInvitedUsersResponse } from './types';

interface InvitedUserNode {
  id: string;
  name: string;
  accessType: ChatAccessType;
}

const getChatInvitedUsersApi = api.injectEndpoints({
  endpoints: (builder) => ({
    /** Everyone the chat is currently shared with, and at what access level. */
    getChatInvitedUsers: builder.query<GetChatInvitedUsersResponse, GetChatInvitedUsersRequest>({
      query: ({ chatId }) => ({
        url: 'chat/list-invited-users',
        method: 'GET',
        params: { chatId },
      }),
      transformResponse: (response: { users: InvitedUserNode[] }) => ({
        users: response.users.map(({ id, name, accessType }) => ({ userId: id, name, accessType })),
      }),
      providesTags: (_result, _error, { chatId }) => [{ type: CHAT_SHARING_TAG, id: chatId }],
    }),
  }),
});

export const { useGetChatInvitedUsersQuery } = getChatInvitedUsersApi;
